import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ServiceOrderInvoiceFormComponent} from "../service-order-invoice-form/service-order-invoice-form.component";


@Component({
    selector: 'app-service-order-completed-modal',
    templateUrl: './service-order-completed-modal.component.html',
    styleUrl: './service-order-completed-modal.component.scss'
})
export class ServiceOrderCompletedModalComponent {

    @ViewChild('data') data!: ServiceOrderInvoiceFormComponent;

    public serviceOrderID = 0;
    public checked = false;
    public statusArchive = false;

    constructor(private dialogRef: MatDialogRef<ServiceOrderCompletedModalComponent>,
                @Inject(MAT_DIALOG_DATA)
                data: {
                    serviceOrderID: number,
                    statusArchive: boolean
                }) {
        this.serviceOrderID = data.serviceOrderID;
        this.statusArchive = data.statusArchive;
    }

    public completed(): void {
        if (this.statusArchive) {
            const data = {
                status: 'completed',
                ...this.data.invoiceForm.getRawValue()
            }
            this.dialogRef.close(data);
        } else this.dialogRef.close();
    }
}
